/**
 * Job History Component
 * Shows recent fabrication jobs from SmartSQL
 */

import { useFabStore } from '../store';

export function JobHistory() {
  const { jobHistory, setCurrentJob } = useFabStore();

  if (jobHistory.length === 0) {
    return (
      <div className="border-t border-slate-700 p-4">
        <h3 className="text-sm font-medium text-slate-400 mb-2">
          📋 Job History
        </h3>
        <p className="text-xs text-slate-500 text-center py-4">
          No jobs yet. Fabricate an asset to see history.
        </p>
      </div>
    );
  }

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'completed':
        return 'text-fab-success';
      case 'processing':
        return 'text-fab-warning';
      case 'failed':
        return 'text-fab-error';
      default:
        return 'text-slate-400';
    }
  };

  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'completed':
        return '✅';
      case 'processing':
        return '⏳';
      case 'failed':
        return '❌';
      default:
        return '⏸️';
    }
  };

  return (
    <div className="border-t border-slate-700 p-4 max-h-48 overflow-y-auto">
      <h3 className="text-sm font-medium text-slate-400 mb-2">
        📋 Job History
      </h3>
      <div className="space-y-2">
        {jobHistory.map((job) => (
          <button
            key={job.job_id}
            onClick={() => setCurrentJob(job)}
            className="w-full text-left p-2 rounded bg-slate-800/50 hover:bg-slate-800
                       border border-slate-700 transition-colors"
          >
            <div className="flex items-center justify-between">
              <span className="text-xs font-mono text-slate-400">
                {job.job_id.slice(0, 8)}...
              </span>
              <span className={`text-xs ${getStatusColor(job.status)}`}>
                {getStatusIcon(job.status)} {job.status}
              </span>
            </div>
            <div className="text-xs text-slate-500 mt-1">
              {job.profile} • {new Date(job.created_at).toLocaleTimeString()}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
